<template>
    <div class="col-md-8 mx-auto">
        <page-title :title="$t('planning.planning')" :showTitle="false"></page-title>
        <div>
            <button v-if="hasCreateRights" class="btn btn-primary" @click="goToCreate">{{ $t('buttons.create.btnText') }}</button>
        </div>
        <div class="card">

        </div>
    </div>
</template>

<script>
    import PageTitle from '../../components/common/PageTitle';

    export default {
        components: {
            PageTitle
        },
        methods: {
            goToCreate() {
                if (!this.hasCreateRights) {
                    return;
                }

                this.$router.push('/planning/create');
            }
        },
        computed: {
            hasCreateRights() {
                return this.$store.getters.claims.planning.create;
            },
        }
    }
</script>
